import { createSelector } from 'reselect'
import { hasGarageInitErrors } from '../garage/selectors'
import { hasAvailabilityLoadingErrors } from '../availability/selectors'

const getAppState = state => state.app

export const getAppDomain = createSelector(
  getAppState,
  appState => appState.domain
)

export const getAppPDV = createSelector(
  getAppState,
  appState => appState.pdvID
)

export const isAppInitialized = createSelector(
  getAppState,
  appState => appState.isInitialized
)

export const getAppInitError = createSelector(
  getAppState,
  appState => appState.initError
)

export const hasAppInitErrors = createSelector(
  getAppInitError,
  intiError => intiError !== null
)

export const getAppBookingError = createSelector(
  getAppState,
  appState => appState.bookingError
)

export const hasAlreadyBookedError = createSelector(
  getAppBookingError,
  error => {
    return (
      error !== null &&
      !!error.request &&
      !!error.response &&
      error.response.status === 500 &&
      error.response.data.exceptionCode === 1005
    )
  }
)

export const hasAppGenericBookingErrors = createSelector(
  getAppBookingError,
  hasAlreadyBookedError,
  (error, isAlreadyBooked) => error !== null && !isAlreadyBooked
)

export const hasAppGenericErrors = createSelector(
  hasAppInitErrors,
  hasAppGenericBookingErrors,
  hasGarageInitErrors,
  hasAvailabilityLoadingErrors,
  (appError, bookingError, garageError, availabilitiesError) =>
    appError || bookingError || garageError || availabilitiesError
)
